import React, { useState } from "react";
import "./puja-campaign-home.scss";
import Image from "next/image";
import { toast } from "react-toastify";

import Btn from "@/components/pujaCampaign2025/btn";
import { createUser } from "@/customHooks/campaign/durgaPuja2025/createUser";

import homePic from "@/../public/campaign/puja-2025/home-pic.png";

const toastOptions = {
  position: "top-left",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export default function Home({ onNextComp, setUserId, setGender, setCredits }) {
  const [errorMsg, setErrorMsg] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    whatsapp: "",
    gender: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  // Handle form input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "whatsapp") {
      if (value.length > 10) {
        return;
      }
      if (value.length === 10) {
        setErrorMsg("");
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.name || !formData.whatsapp || !formData.gender) {
      toast.error("Please fill in all required fields.", toastOptions);
      return;
    }

    if (formData.whatsapp.length < 10) {
      setErrorMsg("Please enter 10 digit number*");
      return;
    }

    setIsLoading(true);

    // call the createUser function to submit the form data
    const response = await createUser({
      name: formData.name,
      whatsapp: formData.whatsapp,
    });

    if (!response) {
      toast.error("Something went wrong, please try again.", toastOptions);
      setIsLoading(false);
      return;
    }

    console.log("User created:", response);
    setUserId(response?.user?._id);
    setGender(formData.gender);
    setCredits(response?.user?.credits);

    setIsLoading(false);
    onNextComp("bg");
    // setTimeout(() => {
    // }, 2000);
  };

  return (
    <div className="flex-col-center PujaCampaignHome">
      <h1 className="pageHeading">PLEASE FILL THE FORM</h1>

      <Image
        src={homePic}
        alt="home-pic"
        objectFit="cover"
        className="homePic"
      />

      <form className="flex-col-center form">
        {/* Name */}
        <div className="flex-col-center formFieldBox">
          <label htmlFor="name">Name*</label>
          <div className="flex-row-center inputBox">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name"
            />
          </div>
        </div>

        {/* WhatsApp No. */}
        <div className="flex-col-center formFieldBox">
          <label htmlFor="whatsapp">Whatsapp No.*</label>
          <div className="flex-row-center inputBox">
            <input
              type="number"
              id="whatsapp"
              name="whatsapp"
              value={formData.whatsapp}
              onChange={handleChange}
              required
              placeholder="Enter your whatsapp number"
            />
          </div>
          {errorMsg && <span className="errMsg">{errorMsg}</span>}
        </div>

        <div className="flex-col-center radioFieldBox">
          <label>Select Your Gender*</label>
          <div className="flex-row-center radioWrapper">
            <div className="flex-row-center radio">
              <input
                type="radio"
                name="gender"
                value="male"
                id="male"
                checked={formData.gender === "male"}
                onChange={handleChange}
                required
              />
              <label className="flex-row-center" htmlFor="male">
                Male
              </label>
            </div>
            <div className="flex-row-center radio">
              <input
                type="radio"
                name="gender"
                value="female"
                id="female"
                checked={formData.gender === "female"}
                onChange={handleChange}
                required
              />
              <label htmlFor="female">Female</label>
            </div>
          </div>
        </div>
      </form>

      <Btn
        btnTxt={"Get a Selfie with Maa"}
        onClick={handleSubmit}
        isLoading={isLoading}
        isBigBtn={true}
      />
    </div>
  );
}
